import * as RadixCheckbox from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';
import { LABEL_TEXT } from './tokens';

interface CheckboxProps {
  readonly label: string;
  readonly checked: boolean;
  readonly onChange: (checked: boolean) => void;
  readonly disabled?: boolean;
  readonly id?: string;
  readonly description?: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  label,
  checked,
  onChange,
  disabled,
  id,
  description,
}) => {
  const checkboxId = id ?? `checkbox-${label.toLowerCase().replace(/\s+/g, '-')}`;

  return (
    <div className="flex items-start gap-3">
      <RadixCheckbox.Root
        id={checkboxId}
        checked={checked}
        onCheckedChange={onChange}
        disabled={disabled}
        className="w-4 h-4 rounded border border-slate-200 bg-white data-[state=checked]:bg-blue-600 data-[state=checked]:border-blue-600 flex items-center justify-center transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1 shrink-0 mt-0.5 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <RadixCheckbox.Indicator>
          <Check className="w-3 h-3 text-white" />
        </RadixCheckbox.Indicator>
      </RadixCheckbox.Root>
      <div className="flex flex-col">
        <label htmlFor={checkboxId} className={`${LABEL_TEXT} cursor-pointer`}>
          {label}
        </label>
        {description !== undefined && (
          <span className="text-sm text-slate-500 mt-0.5">{description}</span>
        )}
      </div>
    </div>
  );
};
